import { render, staticRenderFns } from "./myCollectionAnswer.vue?vue&type=template&id=fa51244e&scoped=true&"
import script from "./myCollectionAnswer.vue?vue&type=script&lang=js&"
export * from "./myCollectionAnswer.vue?vue&type=script&lang=js&"
import style0 from "./myCollectionAnswer.vue?vue&type=style&index=0&id=fa51244e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa51244e",
  null
  
)

export default component.exports